import { buildSrpPagePath } from './srp-pagination';

// Cheap suffix gate for near-me routing; slug membership is confirmed against the
// BE catalog (isActiveSrpSlug) by the caller.
export const NEAR_ME_SLUG_SUFFIX = '-near-me';

export function isNearMeSlugCandidate(segment: string): boolean {
  return segment.length > NEAR_ME_SLUG_SUFFIX.length && segment.endsWith(NEAR_ME_SLUG_SUFFIX);
}

// Base path that paginated canonicals and rel=prev/next consolidate on: the BE
// canonical's slug when it is itself a near-me slug — duplicate slugs
// canonicalize within the near-me space (homes-for-rent-near-me → houses-near-me,
// HP-8001) — otherwise the request slug, so the base never leaves the near-me
// URL space.
export function nearMeCanonicalBase(beCanonicalPath: string | undefined, nearMeSlug: string): string {
  const segments = (beCanonicalPath ?? '').split('/').filter(Boolean);
  return segments.length === 1 && isNearMeSlugCandidate(segments[0]) ? `/${segments[0]}` : `/${nearMeSlug}`;
}

// The canonical path for the page actually being rendered. Both the page metadata
// and the JSON-LD graph resolve their URL through this, so the two cannot
// disagree — page 2+ used to publish the page-1 URL in JSON-LD while
// <link rel="canonical"> pointed at the paginated one.
export function nearMeCanonicalPath(
  beCanonicalPath: string | undefined,
  nearMeSlug: string,
  page: number,
): string {
  // Page 1 keeps the BE-owned canonicalPath (pre-existing contract).
  if (page === 1) return beCanonicalPath || `/${nearMeSlug}`;
  return buildSrpPagePath(nearMeCanonicalBase(beCanonicalPath, nearMeSlug), page);
}
